module.exports = __webpack_public_path__ + "img/949.54e48f54.png";